import React from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { COLORS } from '../../constants/colors';

function ProfileDetails({ user, updateModalShow }) {
    const {
        productReducers: {products = []}
    } = useSelector((state) => state)

    if (!user) {
        return null;
    }

    // Ensure products is an array
    const safeProducts = Array.isArray(products) ? products : [];

    return (
        <Card className='border-0 shadow fs-6 text-center text-lg-start mx-3 mx-md-0'>
            <Card.Header className='text-center fw-bold p-3 h4' style={{ color: COLORS.PLUM }}>User Profile</Card.Header>
            
            <Card.Body className='p-4'>
                <Row className='pb-3 align-items-center'>
                    <Col lg={4} className='pb-3 pb-lg-0 d-flex justify-content-center align-items-center'>
                        <div className='border rounded-circle border-light shadow-sm d-flex justify-content-center align-items-center' 
                             style={{
                                 width: '64px', 
                                 height: '64px',
                                 backgroundColor: COLORS.WARM_CONCRETE
                             }}>
                            <i className="fa-solid fa-user" style={{ color: COLORS.PLUM, fontSize: '1.5rem' }}></i>
                        </div>
                    </Col>
                    <Col lg={8}>
                        <Row className='mb-2'>
                            <Col xs={6} className='text-muted'>Username</Col>
                            <Col xs={6} className='fw-medium'>{user.name || 'No name set'}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} className='text-muted'>Email</Col>
                            <Col xs={6} className='fw-medium'>{user.email || 'No email'}</Col>
                        </Row>
                    </Col>
                </Row>
                
                <hr className='my-4' style={{ opacity: 0.1 }} />

                <Row className='mb-3'>
                    <Col lg={4} className='d-flex justify-content-center align-items-center'>
                        <i className="fa-solid fa-location-dot" style={{ color: COLORS.PLUM, fontSize: '1.25rem' }}></i>
                    </Col>
                    <Col lg={8}>
                        <Link to={'/profile/address'} className='text-muted text-decoration-none hover-primary'>My Address</Link>
                    </Col>
                </Row>

                <hr className='my-4' style={{ opacity: 0.1 }} />

                <Row className='mb-3'>
                    <Col lg={4} className='d-flex justify-content-center align-items-center'>
                        <i className="fa-solid fa-credit-card" style={{ color: COLORS.PLUM, fontSize: '1.25rem' }}></i>
                    </Col>
                    <Col lg={8}>
                        <Link to={'/profile/cards'} className='text-muted text-decoration-none hover-primary'>My Cards</Link>
                    </Col>
                </Row>

                <hr className='my-4' style={{ opacity: 0.1 }} />

                <Row className='mb-3'>
                    <Col lg={4} className='d-flex justify-content-center align-items-center'>
                        <i className="fa-solid fa-hand-sparkles" style={{ color: COLORS.PLUM, fontSize: '1.25rem' }} />
                    </Col>
                    <Col lg={8}>
                        <Link to={'/profile'} className='text-muted text-decoration-none hover-primary'>My Bids</Link>
                    </Col>
                </Row>

                <hr className='my-4' style={{ opacity: 0.1 }} />

                <Row className='mb-4'>
                    <Col lg={4} className='d-flex justify-content-center align-items-center'>
                        <i className="fa-solid fa-box" style={{ color: COLORS.PLUM, fontSize: '1.25rem' }}></i>
                    </Col>
                    <Col lg={8}>
                        <Link to={'/profile/orders'} className='text-muted text-decoration-none hover-primary'>My Orders</Link>
                    </Col>
                </Row>

                <Row>
                    <Col className='d-flex justify-content-center'>
                        <Button 
                            className="edit-profile rounded-circle" 
                            onClick={updateModalShow} 
                            variant="custom" 
                            style={{ 
                                backgroundColor: COLORS.PLUM, 
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none'
                            }}>
                            <i className="fa-regular fa-pen-to-square" style={{ color: "#fff", fontSize: '1.25rem' }}></i>
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default ProfileDetails;
